import { Component, inject, ViewChild } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatListModule } from '@angular/material/list'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatButtonModule } from '@angular/material/button'
import { getClient, getConciergeUser } from '@monorepo-channels/channels/domain'
import { CommonModule } from '@angular/common'
import { Router, RouterLink } from '@angular/router'
import { MenuMobileComponent } from '../menu-mobile/menu-mobile.component'
import { AbstractComponent } from '@monorepo-channels/channels/domain'

@Component({
	imports: [
		MatIconModule,
		// DivisorUiComponent,
		MatSidenavModule,
		MatToolbarModule,
		MatIconModule,
		MatListModule,
		MatButtonModule,
		CommonModule,
		RouterLink,
		// UserProfileComponent,
		MenuMobileComponent,
		// MenuWebComponent,
	],
	selector: 'pm-header',
	standalone: true,
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends AbstractComponent {
	public router = inject(Router)
	public client$ = this.store.select(getClient)
	public concierge$ = this.store.select(getConciergeUser)
	@ViewChild('menu') menu!: MenuMobileComponent

	openMenu() {
		this.menu.toggle()
	}
}
